import React, { FunctionComponent } from 'react';
import {Page, RequestHelper} from 'b302-frontend-library';

import UniversityForm, { UniversitySaveEvent } from '../admin/partials/university/UniversityForm';
import UniversityRepository, {UniversityFormRequest} from '../../networking/repos/UniversityRepository';
import University from '../../networking/models/University';
import {toast, ToastContentProps} from 'react-toastify';
import {useUniversityCreateMutation, useUniversityUpdateMutation} from '../query/University/Mutation';

interface Props {
    university?: University;
}

const UniversityFormPage: FunctionComponent<Props> = ({ university }) => {

    const universityCreateMutation = useUniversityCreateMutation();
    const universityUpdateMutation = useUniversityUpdateMutation();

    const onUniversitySave = async (e: UniversitySaveEvent) => {
        toast.promise(saveUniversity(e), {
            pending: 'Saving university',
            success: 'Saved university!',
            error: { render: (e: ToastContentProps<any>) => {
                const errors = e.data?.errors;
                const errorKeys = Object.keys(errors ?? {});
                return errors ? errors[errorKeys[0] as keyof typeof errors] : 'Error saving university!';
            } }
        });
    };

    const createOrUpdateUniversity = async (data: UniversityFormRequest): Promise<University> => {
        let response: University;

        if(!university?.id) {
            response = await universityCreateMutation.mutateAsync(data);
        } else {
            response = await universityUpdateMutation.mutateAsync({
                universityId: university.id,
                request: data
            });
        }

        return response;
    };

    const saveUniversity = async  ({ data, images, imagesToDelete }: UniversitySaveEvent) => {
        const universityRepo = new UniversityRepository();

        const university = await createOrUpdateUniversity(data);

        if(images.length) {
            const formData = RequestHelper.convertToFormData({
                images: images.map(i => i.file),
                order: images.map(i => i.number + 1),
            });

            await universityRepo.uploadImages(university?.id!, formData);
        }

        if(imagesToDelete.length) {
            await universityRepo.deleteImages(university?.id!, imagesToDelete);
        }
    };

    return (
        <Page className={'new-university-page'}>
            <UniversityForm university={university} onUniversitySave={onUniversitySave} />
        </Page>
    );
};

export default UniversityFormPage;
